import React from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  Row,
  Typography,
  NotificationList,
} from '@lib/index';
import { Modal } from 'antd';
import { NotificationModalProps } from './types';

const NotificationModal = ({
  notifications,
  open,
  onClose,
  onMarkAsRead,
}:NotificationModalProps) => {
  const { Title } = Typography;
  const { t } = useTranslation();
  const handleClose = () => {
    if (!notifications || notifications.length === 0) {
      onClose();
    }
  };
  return (
    <Row>
      <Formik
        enableReinitialize
        initialValues={{}}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit={() => {}}
      >
        <Modal
          visible={open}
          width={820}
          title={<Title level={4} className="text-blue-900">{t('notification.updates')}</Title>}
          className="rounded-xl"
          bodyStyle={{
            maxHeight: '70vh',
            overflowY: 'auto',
          }}
          footer={null}
          onCancel={handleClose}
          closable
          maskClosable={false}

        >
          <Row justify="center" gutter={[16, 0]}>
            <NotificationList
              notifications={notifications}
              onMarkAsRead={onMarkAsRead}
            />
          </Row>
        </Modal>
      </Formik>
    </Row>
  );
};

export default NotificationModal;
